module.exports = __webpack_public_path__ + "static/img/2.4027678.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/4/1/2.png
// module id = W3yR
// module chunks = 2